import React from 'react';
import QueryInputRow from './QueryInputRow';

const QueryInputRowContainer = () => {
  return <QueryInputRow />;
};

export default QueryInputRowContainer;
